module.exports = __webpack_public_path__ + "img/teatox.b9cbb71a.svg";